import React from 'react';
export function CommentIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57 4.107C5.153 4.107 4 5.228 4 6.607v7c0 1.38 1.153 2.5 2.57 2.5H9.6c.351 0 .676.185.857.485L12 19.164l1.543-2.572a1 1 0 01.857-.485h3.03c1.416 0 2.57-1.12 2.57-2.5v-7c0-1.379-1.154-2.5-2.57-2.5H6.57zm5.43 18c-.352 0-.677-.185-.858-.485l-2.109-3.515H6.57c-2.52 0-4.57-2.019-4.57-4.5v-7c0-2.48 2.05-4.5 4.57-4.5h10.86c2.52 0 4.57 2.02 4.57 4.5v7c0 2.481-2.05 4.5-4.57 4.5h-2.464l-2.109 3.515c-.18.3-.506.485-.857.485z"
  }));
}